<!-- Header -->
<h3 mat-dialog-title translate>
    Recipient Change
</h3>

<!-- Body -->
<mat-dialog-content translate>
    In order to prevent contacts from seeing each <br />
    other's email addresses, when more than one <br />
    parent/contact recipient is selected, they can only <br />
    be marked as BCC.
</mat-dialog-content>

<!-- Footer -->
<mat-dialog-actions style="position: sticky">
    <div class="flex-footer-left">
    </div>
    <div class="flex-footer-right">
        <tyl-button image="save.png" label="OK" (clickEvent)="ok()"></tyl-button>
    </div>
</mat-dialog-actions>